import React, { useState } from 'react';
import GoogleLogin from 'react-google-login';
import { FcGoogle } from 'react-icons/fc';
import chirpVideo from '../assets/flying-kites.mp4';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/camera-logo.png';
import {gapi} from 'gapi-script';
import '../index.css';
import { client } from '../client';
import clickSound from '../assets/camera-shutter.mp3';



const Login = () => {

  const [playSound, setPlaySound] = useState(false);

  const handleClick = () => {
    setPlaySound(true);
  };
  const navigate = useNavigate(); //gapi

  const responseGoogle = (response) => {
    if (response.error) {
      // Handle error case
      console.log('Error logging in:', response.error);
    } else {
      // Handle successful login case
      const { profileObj } = response;
      const { name, googleId, imageUrl } = response.profileObj;

      localStorage.setItem('user', JSON.stringify(response.profileObj));
      console.log('Successfully Logged in:', profileObj);

      const doc = {
        _id: googleId,
        _type: 'user',
        userName: name,
        image: imageUrl,
      }

      client.createIfNotExists(doc)
        .then(() => {
          navigate('/', { replace: true })
        })
      // Continue with the necessary logic for a successful login
    }
  };

  const onSuccess = (response) => {
    // Handle the successful login response
    responseGoogle(response);
  };

  const onFailure = (response) => {
    // Handle the failed login response
    responseGoogle(response);
  };

  return (
    <div className='flex justify-start items-center flex-col h-screen'>
      <div className='relative w-full h-full'>
        <video
          src={chirpVideo}
          type="video/mp4"
          loop
          controls={false}
          muted
          autoPlay
          className='w-full h-full object-cover'
        />

        <div className='absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-blackOverlay'>
          <div className='p-5'>
            <img className='img-login cursor-pointer' src={logo} width='50px' alt='logo' id="logo-login" onClick={handleClick}/>
            {playSound && <audio src={clickSound} autoPlay/>}
            

            <h2 className='text-[#8A0303] font-bold'><span className='mr-0 chirp'>Chirp</span><span className='ml-0 sky'>sky</span></h2>
          </div>
          <div className='shadow-2xl'>
            <GoogleLogin
              clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
              render={(renderProps) => (
                <button
                type='button'
                className='bg-black flex justify-center items-center p-3 rounded-lg cursor-pointer outline-none w-60 text-[#8A0303] font-bold'
                onClick={() => {
                  renderProps.onClick();
                  handleClick();
                }}
                disabled={renderProps.disabled}
              >
                <FcGoogle className='mr-4 sign-in-google' /> Sign in with Google
              </button>
              )}
              onSuccess={onSuccess}
              onFailure={onFailure}
              cookiePolicy='single_host_origin'
              //isSignedIn={true}
              //crossOriginOpenerPolicy='' 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
